<template>
  <div class="flex items-center mb-5">
    <label class="relative mr-8 sm:mr-0 md:mr-0 inline-block h-6 w-6">
      <input
        :id="uid"
        :name="name"
        class="invisible appearance-none peer"
        :type="type ?? 'checkbox'"
        :value="modelValue"
        @change="$emit('input', val ?? $event.target.checked)"
        :checked="checked"
      />
      <span
        class="absolute inset-0 w-6 h-6 bg-white border cursor-pointer after:absolute after:w-4 after:h-4 border-grey-450"
        :class="`${rounded ? 'rounded-[3.125rem] after:rounded-full ' : ''} ${checkmark ? 'peer-checked:after:[content:\'✓\'] after:text-2xl font-bold after:-top-1.5 after:left-1' : 'after:left-[3px] after:top-1/2 after:-translate-y-1/2 peer-checked:after:bg-green-400'}`"
      >
      </span>
    </label>
    <label
      :for="uid"
      class="inline-block ml-2.5"
      :class="{ 'font-display text-base': boldText }"
      >{{ label }}</label
    >
  </div>
</template>
<script>
export default {
  name: 'switch-toggle',
  data() {
    return {
      uid: `switch-${Math.random().toString(36).slice(2, 9)}`
    }
  },
  props: {
    name: String,
    rounded: {
      type: Boolean,
      default: true
    },
    checkmark: {
      type: Boolean,
      default: false
    },
    type: String,
    label: {},
    val: {
      type: String,
      default: undefined
    },
    checked: {
      type: Boolean,
      required: false,
    },
    boldText: {
      type: Boolean,
      default: true
    },
    modelValue: {}
  }
}
</script>
